import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Row } from 'reactstrap';
import { useFetchWrapper } from '../../../hooks/useFetchWrapper';
import { VehicleImage } from './VehicleImage';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentBody } from '../../Shared/Content/ContentBody';

interface IDetailVeiwProps {
    vehicleID: number
    closeCallback: () => void,
}

interface IVehicle {
    vehicleID: number,
    model: string,
    detailedModel: string,
    modelYear: number,
    classificationName: string,
    allElectricRange: number,
    fullRange: number,
    vehicleTypeName: string,
    vehicleSecondaryTypeName: string,
    isAvailable: boolean,
    isBuyAmericaCompliant: boolean,
    vehicleDriveTrainName: string,
    manufacturerName: string,
    expectedAvailability: number,
    batterySize: number,
    grossVehicleWeightRating: string,
    grossCarryingWeightRating: number,
    vehicleFHWAClassTypeName: string,
    msrp: number,
    seatingCapacity: number,
    citykWh100mi: number,
    highwaykWh100mi: number,
    combinedkWh100mi: number,
    imageID: string,
    imagePath: string,
    vehicleTypeImageID: string,
    vehicleTypeImagePath: string,
    manufacturerWebsiteURL: string,
    vehicleDriveTrainDescription: string,
    isVehicleTypeImage: boolean
}

export const DetailView = ({ vehicleID, closeCallback }: IDetailVeiwProps) => {
    const fetchWrapper = useFetchWrapper();

    const [vehicleDetail, setVehicleDetail] = useState<IVehicle>();

    const getVehicleDetail = () => {
        fetchWrapper.get(`VehicleCatalog/VehicleInfo/${vehicleID}`)
            .then((data) => {
                if (data.vehicle) {
                    setVehicleDetail(data.vehicle);
                }
            });
    }

    useEffect(() => {
        getVehicleDetail();
    }, []);

    const calculateMSRP = (msrp: number) => {
        if (msrp) {
            return '$' + msrp.toLocaleString();
        }
        else {
            return 'Coming Soon'
        }
    }

    return (
        <div className="vehicleCatalogDetailView">
            <Row className="pageAnchorsBody">
                <Row className="pageAnchorsSection">
                    <Col sm={8} className="inPageNav" >
                        <Button className="buttonAsLink backArrow iconPositionLeft" onClick={closeCallback} >Back To Results</Button>
                    </Col>
                </Row>
            </Row>
            <ContentBlock className="vehicleDetailBlock">
                <ContentBody>
                        <Col>
                            {vehicleDetail ? (
                                <Card>
                                    <CardHeader>
                                        <Row>
                                            <Col sm={9}>{vehicleDetail.manufacturerName}<span>{vehicleDetail.modelYear}&nbsp;{vehicleDetail.detailedModel}</span></Col>
                                            <Col sm={3} className="text-align-right">{vehicleDetail.vehicleTypeName}<br />MSRP: {calculateMSRP(vehicleDetail.msrp)}</Col>
                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col lg={6} md={6} sm={12} xs={12} className="vehicleImageContainer">
                                                <VehicleImage
                                                    vehicleImagePath={vehicleDetail.imagePath} vehicleTypeImagePath={vehicleDetail.vehicleTypeImagePath}
                                                    vehicleMakeModel={`${vehicleDetail.manufacturerName} ${vehicleDetail.detailedModel}`} showLoadingSymbol={false} />
                                            </Col>
                                            <Col lg={6} md={6} sm={12} xs={12} className="vehicleDescriptionContainer">
                                                <Row>
                                                    <Col className="text-align-center details large">
                                                        <div className="detailsHeading">Range</div>
                                                        <div className="detailsBody">{vehicleDetail.fullRange} miles</div>
                                                    </Col>
                                                    <Col className="text-align-center details large">
                                                        <div className="detailsHeading">Fuel Type</div>
                                                        <div className="detailsBody">{vehicleDetail.classificationName ? vehicleDetail.classificationName : 'Coming Soon'}</div>
                                                    </Col>
                                                </Row>
                                                <Row className="oddRow">
                                                    <Col className="text-align-center details large">
                                                        <div className="detailsHeading">Availability</div>
                                                        <div className="detailsBody">{vehicleDetail.expectedAvailability ? vehicleDetail.expectedAvailability : 'Coming Soon'}</div>
                                                    </Col>
                                                    <Col className="text-align-center details large">
                                                        <div className="detailsHeading">Seats</div>
                                                        <div className="detailsBody">{vehicleDetail.seatingCapacity ? vehicleDetail.seatingCapacity : 'Coming Soon'}</div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="text-align-center details large">
                                                        <div className="detailsHeading">Drivetrain</div>
                                                        <div className="detailsBody">{vehicleDetail.vehicleDriveTrainDescription ? vehicleDetail.vehicleDriveTrainDescription : 'Coming Soon'}</div>
                                                    </Col>
                                                    <Col className="text-align-center details large">
                                                        <div className="detailsHeading">Weight Class</div>
                                                        <div className="detailsBody">{vehicleDetail.vehicleFHWAClassTypeName && vehicleDetail.vehicleFHWAClassTypeName.trim().toLowerCase() !== 'null' ? vehicleDetail.vehicleFHWAClassTypeName : 'Coming Soon'}</div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="text-align-center details large">
                                                        <div className="detailsHeading">Battery</div>
                                                        <div className="detailsBody">{vehicleDetail.batterySize ? vehicleDetail.batterySize + ' kWh' : 'Coming Soon'}</div>
                                                    </Col>
                                                    <Col className="text-align-center details large">
                                                        <div className="detailsHeading">kWh/100 Miles</div>
                                                        <div className="detailsBody">{vehicleDetail.combinedkWh100mi ? vehicleDetail.combinedkWh100mi : 'Coming Soon'}</div>
                                                    </Col>
                                                </Row>
                                                <Row className="stickToBottom details-footer">
                                                    <Col className="text-align-right details noBorder">
                                                        <Button className="solidNeg tertiaryButton iconRightArrow pt-3 pb-3" href={vehicleDetail.manufacturerWebsiteURL} target="_blank">Manufacturer's Website</Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            ) : (
                                <div className="An_error_message_should_go_here_maybe?"></div>
                            )}
                        </Col>
                </ContentBody>
            </ContentBlock>
        </div>
    );
}
